<template>
	<v-card flat>
		<v-calendar
			v-if="show"
			type="day"
			:first-interval="firstInterval"
			interval-minutes="30"
			:interval-count="intervalCout"
			:day-format="getDayFormat"
			v-model="date"
			:events="bookings"
			event-overlap-mode="column"
			event-overlap-threshold="30"
			:hide-header="true"
			@click:event="$refs.detail.showDetail($event)"
		>
			<template v-slot:event="{ event }">
				<booking :event="event" />
			</template>
		</v-calendar>
		<booking-detail ref="detail" @booking:change="bookingChange($event)" />

		<v-overlay :value="loading">
			<v-progress-circular indeterminate size="64" width="2"></v-progress-circular>
		</v-overlay>
	</v-card>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import Booking from './Booking'
import BookingDetail from './BookingDetail'

export default {
	name: 'DayCalendar',

	components: { Booking, BookingDetail },

	computed: {
		...mapGetters({
			date: 'bookings/date',
			month: 'bookings/month',
			bookings: 'bookings/bookings',
			showCancelled: 'bookings/showCancelled',
			beginSlot: 'bookings/beginSlot',
			endSlot: 'bookings/endSlot'
		}),
		firstInterval() {
			return this.beginSlot !== 0 ? this.beginSlot - 1 : 0
		},
		intervalCout() {
			return this.endSlot - this.firstInterval
		},
		show() {
			return this.beginSlot + this.endSlot !== 0
		}
	},

	data() {
		return {
			loading: false
		}
	},

	created() {
		this.load()
	},

	watch: {
		date() {
			this.load()
		},
		showCancelled() {
			this.load()
		}
	},

	methods: {
		...mapActions({
			getBookings: 'bookings/getBookings'
		}),
		async load() {
			this.loading = true
			await this.getBookings()
			this.loading = false
		}
	}
}
</script>

<style lang="scss" scoped></style>
